import styled from "styled-components";
import { COLOR } from "./theme";

const StyledHr = styled.hr`
  border: 1px dashed ${COLOR.LIGHT_GREY};
`;

export default StyledHr;
